import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import '@/style/index.less'
import { COMMON,api,ADDRESS } from "./config/index";
import Public from '@/components'
Vue.use(Public)
Vue.config.productionTip = false
// 挂载api接口
Vue.prototype.$api = api
Vue.prototype.$COMMON = COMMON
Vue.prototype.$ADDRESS = ADDRESS
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
